module.exports = __webpack_public_path__ + "static/media/logo-horizontal.067e57b0.png";